import React from 'react';
import StackTrace from 'stacktrace-js';

const isLocal = process.env.REACT_APP_AUTH_ENV === 'local';
const isDev = process.env.REACT_APP_AUTH_ENV === 'dev';
const isDevelopment = process.env.NODE_ENV === 'development';

const showFullError = isLocal || isDev || isDevelopment;

// function logErrorToMyService(error, info) {

// }

export default class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, error: null, errorInfo: null, mappedStack: null };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true, error };
    }
  
    componentDidCatch(error, errorInfo) {
      this.setState({ errorInfo });
      this.props.onError?.(error, errorInfo);
      // You can also log the error to an error reporting service
      // logErrorToMyService(error, errorInfo);

      // Map stack trace to original source files using source maps
      if (showFullError && error) {
        StackTrace.fromError(error)
          .then((stackframes) => {
            const mappedStack = stackframes
              .map((sf) => {
                const fileName = sf.fileName || '';
                const functionName = sf.functionName || '<anonymous>';
                const lineNumber = sf.lineNumber || '';
                const columnNumber = sf.columnNumber || '';
                return `    at ${functionName} (${fileName}:${lineNumber}:${columnNumber})`;
              })
              .join('\n');
            this.setState({ mappedStack });
          })
          .catch(() => {
            // If source map parsing fails, use the original stack
            this.setState({ mappedStack: error.stack });
          });
      }
    }
  
    render() {
      if (this.state.hasError) {
        if (showFullError) {
          return (
            <div style={{ padding: '20px', fontFamily: 'monospace' }}>
              <h1 style={{ color: '#d32f2f' }}>Something went wrong.</h1>
              <details open style={{ whiteSpace: 'pre-wrap', marginTop: '10px' }}>
                <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '10px' }}>
                  Error Details
                </summary>
                <div style={{ 
                  backgroundColor: '#ffebee', 
                  padding: '15px', 
                  borderRadius: '4px',
                  border: '1px solid #ffcdd2'
                }}>
                  <p style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                    {this.state.error?.toString()}
                  </p>
                  {this.state.mappedStack && (
                    <div style={{ marginTop: '15px' }}>
                      <strong>Stack Trace (Source Mapped):</strong>
                      <pre style={{ 
                        backgroundColor: '#fff', 
                        padding: '10px', 
                        overflow: 'auto',
                        border: '1px solid #e0e0e0',
                        borderRadius: '4px',
                        marginTop: '5px',
                        fontSize: '12px'
                      }}>
                        {this.state.mappedStack}
                      </pre>
                    </div>
                  )}
                  {this.state.errorInfo?.componentStack && (
                    <div style={{ marginTop: '15px' }}>
                      <strong>Component Stack:</strong>
                      <pre style={{ 
                        backgroundColor: '#fff', 
                        padding: '10px', 
                        overflow: 'auto',
                        border: '1px solid #e0e0e0',
                        borderRadius: '4px',
                        marginTop: '5px',
                        fontSize: '12px'
                      }}>
                        {this.state.errorInfo.componentStack}
                      </pre>
                    </div>
                  )}
                </div>
              </details>
            </div>
          );
        }
        return <h1>Something went wrong.</h1>;
      }
  
      return this.props.children; 
    }
  }
